'use client';

import React, { useEffect } from 'react';

import useStores from 'app-migration/store';
import { useStaticRendering } from 'mobx-react';
import { usePathname } from 'next/navigation';

import useRouteLogic from 'hooks/useRouteLogic';

const isServer = typeof window === 'undefined';
// eslint-disable-next-line react-hooks/rules-of-hooks
useStaticRendering(isServer);

const SearchParamsBoundary = () => {
    const pathname = usePathname();

    const { uiStore } = useStores();

    useRouteLogic(true);

    // On rounte change
    useEffect(() => {
        if (uiStore.blockScrollToTop) {
            uiStore.setBlockScrollToTop(false);
        } else {
            // on route, scroll to top
            window.scrollTo(0, 0);
        }
    }, [pathname]);

    return <></>;
};

export default SearchParamsBoundary;
